<script setup lang="ts">
    import ToggleButton from '../ToggleButton.vue';

    interface Props {
        categories: Record<string, boolean>;
    }

    defineProps<Props>();

    const emit = defineEmits<{
        (e: 'select', category: string): void;
    }>();
</script>
<template>
    <div class="flex flex-row gap-4">
        <ToggleButton
            v-for="category in Object.keys(categories)"
            :id="category"
            :key="category"
            :label="category"
            :on-click="() => emit('select', category)"
            :selected="categories[category]"
            :selected-class="'bg-primary-blueberry text-white'"
            class="whitespace-nowrap"
        />
    </div>
</template>
